export {PatientTrendsCard} from './PatientTrendsCard'
